import Layout from "../Layouts/Index.js";
import {Link} from "react-router-dom";

const NotFound = () => {
    return (
        <Layout>
            <div className="bg-white">
                <div className="w-full md:w-9/12 m-auto py-20 flex items-center justify-center">
                    <div className="bg-white overflow-hidden sm:rounded-lg pb-8">
                        <div className="text-center pt-8">
                            <div className="text-green-app">
                                <h1 className="text-9xl font-bold">404</h1>
                                <h1 className="text-6xl font-medium py-8">oops! Page not found</h1>
                                <p className="text-2xl pb-8 px-12 font-medium">
                                    Oops! The page you are looking for does not
                                    exist. It might have been moved or deleted.
                                </p>
                            </div>
                            <Link to="/"
                                className="bg-green-app text-white font-semibold px-6 py-3 rounded-md mr-6">
                                HOME
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default NotFound